'use client'

import { createContext, useContext } from 'react'

// Cấu trúc dữ liệu mới cho một campaign
export interface CampaignInfo {
  isActive: boolean
  data?: Record<string, unknown> | null
}

interface CampaignContextType {
  campaigns: Record<string, CampaignInfo>
}

const CampaignContext = createContext<CampaignContextType>({
  campaigns: {},
})

// Hook mới để lấy toàn bộ object campaigns
export const useAllCampaigns = () => {
  const context = useContext(CampaignContext)
  if (!context) {
    throw new Error('useAllCampaigns must be used within a CampaignProvider')
  }
  return {
    campaigns: context.campaigns,
    isLoading: false, // Dữ liệu được fetch từ server nên không có trạng thái loading ở client
  }
}

// Hook để lấy thông tin một campaign cụ thể
export const useCampaign = (name: string) => {
  const context = useContext(CampaignContext)
  if (!context) {
    throw new Error('useCampaign must be used within a CampaignProvider')
  }
  return context.campaigns[name] // Trả về { isActive, data }
}

/**
 * Hook kiểm tra campaign có đang active không dựa trên isActive (đã bao gồm kiểm tra thời gian tại server/provider).
 */
export const useCampaignActive = (name: string) => {
  const campaign = useCampaign(name)
  if (!campaign) return false

  return !!campaign.isActive
}

interface CampaignProviderProps {
  children: React.ReactNode
  campaigns: Record<string, CampaignInfo>
}

export function CampaignProvider({
  children,
  campaigns,
}: CampaignProviderProps) {
  return (
    <CampaignContext.Provider
      value={{
        campaigns,
      }}
    >
      {children}
    </CampaignContext.Provider>
  )
}
